"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertIsoDateToLocaleFormat = exports.subtractHours = exports.addHours = exports.isEqual = exports.compareAsc = exports.addMonths = exports.subtractMonths = exports.differenceInMinutes = exports.differenceInCalendarDays = exports.getISODay = exports.addDays = exports.subtractDays = exports.isExists = exports.isBefore = exports.isAfter = exports.subtractYears = exports.getYesterdaysDate = exports.getTomorrowsDate = exports.getTodaysDate = exports.startOfDay = exports.parseDateStr = exports.formatDateInTimeZone = exports.formatDate = void 0;
const date_fns_tz_1 = require("date-fns-tz");
const addDays_1 = __importDefault(require("date-fns/addDays"));
const addHours_1 = __importDefault(require("date-fns/addHours"));
const addMonths_1 = __importDefault(require("date-fns/addMonths"));
const compareAsc_1 = __importDefault(require("date-fns/compareAsc"));
const differenceInCalendarDays_1 = __importDefault(require("date-fns/differenceInCalendarDays"));
const differenceInMinutes_1 = __importDefault(require("date-fns/differenceInMinutes"));
const format_1 = __importDefault(require("date-fns/format"));
const getISODay_1 = __importDefault(require("date-fns/getISODay"));
const isAfter_1 = __importDefault(require("date-fns/isAfter"));
const isBefore_1 = __importDefault(require("date-fns/isBefore"));
const isEqual_1 = __importDefault(require("date-fns/isEqual"));
const isExists_1 = __importDefault(require("date-fns/isExists"));
const de_1 = __importDefault(require("date-fns/locale/de"));
const fr_1 = __importDefault(require("date-fns/locale/fr"));
const parse_1 = __importDefault(require("date-fns/parse"));
const startOfDay_1 = __importDefault(require("date-fns/startOfDay"));
const startOfTomorrow_1 = __importDefault(require("date-fns/startOfTomorrow"));
const startOfYesterday_1 = __importDefault(require("date-fns/startOfYesterday"));
const subDays_1 = __importDefault(require("date-fns/subDays"));
const subHours_1 = __importDefault(require("date-fns/subHours"));
const subMonths_1 = __importDefault(require("date-fns/subMonths"));
const subYears_1 = __importDefault(require("date-fns/subYears"));
const langToLocalDict = {
    de: de_1.default,
    fr: fr_1.default,
};
const formatDate = (date, dateFormat = 'yyyy-MM-dd', language) => {
    const locale = language ? langToLocalDict[language] : undefined;
    return (0, format_1.default)(date, dateFormat, {
        locale,
    });
};
exports.formatDate = formatDate;
const formatDateInTimeZone = (date, dateFormat = 'yyyy-MM-dd', language, timeZone) => {
    const locale = language ? langToLocalDict[language] : undefined;
    return (0, date_fns_tz_1.formatInTimeZone)(date, timeZone, dateFormat, {
        locale,
    });
};
exports.formatDateInTimeZone = formatDateInTimeZone;
const parseDateStr = (dateStr, dateFormat = 'yyyy-MM-dd', backupDate = new Date()) => {
    return (0, parse_1.default)(dateStr, dateFormat, backupDate);
};
exports.parseDateStr = parseDateStr;
const startOfDay = (date) => (0, startOfDay_1.default)(date);
exports.startOfDay = startOfDay;
const getTodaysDate = () => (0, exports.startOfDay)(new Date());
exports.getTodaysDate = getTodaysDate;
const getTomorrowsDate = () => (0, startOfTomorrow_1.default)();
exports.getTomorrowsDate = getTomorrowsDate;
const getYesterdaysDate = () => (0, startOfYesterday_1.default)();
exports.getYesterdaysDate = getYesterdaysDate;
const subtractYears = (date, years) => (0, subYears_1.default)(date, years);
exports.subtractYears = subtractYears;
const isAfter = (date, dateToCompare) => (0, isAfter_1.default)(date, dateToCompare);
exports.isAfter = isAfter;
const isBefore = (dateToCompare, date) => (0, isBefore_1.default)(dateToCompare, date);
exports.isBefore = isBefore;
const isExists = (year, month, day) => {
    return (0, isExists_1.default)(year, month, day);
};
exports.isExists = isExists;
const subtractDays = (date, days) => (0, subDays_1.default)(date, days);
exports.subtractDays = subtractDays;
const addDays = (date, amountOfDays) => (0, addDays_1.default)(date, amountOfDays);
exports.addDays = addDays;
const getISODay = (date) => (0, getISODay_1.default)(date);
exports.getISODay = getISODay;
function differenceInCalendarDays(leftDate, rightDate) {
    return (0, differenceInCalendarDays_1.default)(leftDate, rightDate);
}
exports.differenceInCalendarDays = differenceInCalendarDays;
function differenceInMinutes(leftDate, rightDate) {
    return (0, differenceInMinutes_1.default)(leftDate, rightDate);
}
exports.differenceInMinutes = differenceInMinutes;
const subtractMonths = (date, months) => (0, subMonths_1.default)(date, months);
exports.subtractMonths = subtractMonths;
const addMonths = (date, months) => (0, addMonths_1.default)(date, months);
exports.addMonths = addMonths;
const compareAsc = (dateLeft, dateRight) => (0, compareAsc_1.default)(dateLeft, dateRight);
exports.compareAsc = compareAsc;
const isEqual = (aDate, bDate) => (0, isEqual_1.default)(aDate, bDate);
exports.isEqual = isEqual;
const addHours = (date, amountOfHours) => (0, addHours_1.default)(date, amountOfHours);
exports.addHours = addHours;
const subtractHours = (date, hours) => (0, subHours_1.default)(date, hours);
exports.subtractHours = subtractHours;
const convertIsoDateToLocaleFormat = (isoDate, language = 'de') => {
    const date = new Date(isoDate);
    const longMonthFormat = date.toLocaleString(language, { month: 'long' });
    const day = date.getDate();
    const year = date.getFullYear();
    const dot = language === 'de' ? '.' : '';
    return language === 'en'
        ? `${longMonthFormat} ${day}, ${year}`
        : `${day}${dot} ${longMonthFormat} ${year}`;
};
exports.convertIsoDateToLocaleFormat = convertIsoDateToLocaleFormat;
//# sourceMappingURL=date.js.map